import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const SIZE_PX: Record<NonNullable<SpinnerProps['size']>, number> = {
  sm: 16,
  md: 24,
  lg: 40,
};

export const Spinner = ({
  size = 'md',
  label = 'Carregando',
  className,
  ...rest
}: SpinnerProps) => {
  const px = SIZE_PX[size];
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn('inline-flex items-center justify-center text-brand', className)}
      {...rest}
    >
      <svg
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="none"
        className="animate-spin"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path
          d="M22 12a10 10 0 0 1-10 10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{label}…</span>
    </div>
  );
};

/** Centered brand-yellow wheel for screens and lists that are still loading. */
export const LoadingState = ({
  size = 'md',
  className,
  label,
}: {
  size?: SpinnerProps['size'];
  className?: string;
  label?: string;
}) => (
  <div className={cn('flex items-center justify-center py-10', className)}>
    <Spinner size={size} label={label} />
  </div>
);
